import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Button,
  IconButton,
} from '@mui/material';
import { FavoriteBorder, LocationOn, Chat, Call } from '@mui/icons-material';

const Three = () => {
  return (
    <Card sx={{ borderRadius: 2, boxShadow: 3, maxWidth: 400, overflow: 'hidden', margin: '20px auto' }}>
      {/* Image */}
      <Box sx={{ height: 180, position: 'relative' }}>
        <img
          src="/default-image.jpg"
          alt="Property"
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      </Box>

      <CardContent sx={{ px: 2, py: 1 }}>
        {/* Title and Price */}
        <Box display="flex" justifyContent="space-between" mb={1}>
          <Typography variant="subtitle1" fontWeight="bold" noWrap>
            Residential Plot - Green Valley
          </Typography>
          <Typography variant="body2" fontWeight="bold" color="primary">
            ₹25,00,000
          </Typography>
        </Box>

        {/* Location and Date */}
        <Box display="flex" justifyContent="space-between" mb={1}>
          <Typography variant="caption" color="text.secondary">
            Sector 45, Gurgaon
          </Typography>
          <Typography variant="caption" color="text.secondary">
            29/05/2025
          </Typography>
        </Box>

        {/* Property Info Row */}
        <Box
          sx={{
            display: 'flex',
            border: '1px solid #ccc',
            borderRadius: 1,
            overflow: 'hidden',
            mb: 1,
          }}
        >
          <Box sx={{ flex: 1, p: 1, textAlign: 'center', borderRight: '1px solid #ccc' }}>
            <Typography variant="caption" color="text.secondary">
              <strong>Facing</strong>
            </Typography>
            <Typography variant="body2">East</Typography>
          </Box>
          <Box sx={{ flex: 1, p: 1, textAlign: 'center', borderRight: '1px solid #ccc' }}>
            <Typography variant="caption" color="text.secondary">
              <strong>Area</strong> (40*40)
            </Typography>
            <Typography variant="body2">1600 sq ft</Typography>
          </Box>
          <Box sx={{ flex: 1, p: 1, textAlign: 'center' }}>
            <Typography variant="caption" color="text.secondary">
              <strong>Posted By</strong>
            </Typography>
            <Typography variant="body2">Owner/Agent</Typography>
          </Box>
        </Box>

        {/* Buttons Row */}
    {/* Buttons Row */}
<Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 1, mb: 1, flexWrap: 'wrap' }}>
  <Button
    startIcon={<FavoriteBorder />}
    variant="contained"
    sx={{
      backgroundColor: '#F1C93B',
      color: 'black',
      fontSize: '0.60rem',
      textTransform: 'none',
      flex: 1,
      minWidth: '100px',
      '&:hover': { backgroundColor: '#e3b92f' },
    }}
  >
    Wishlist (5)
  </Button>

  <Button
    variant="contained"
    sx={{
      backgroundColor: '#2ECC71',
      color: 'white',
      fontSize: '0.60rem',
      textTransform: 'none',
      flex: 1,
      minWidth: '100px',
      '&:hover': { backgroundColor: '#28b765' },
    }}
  >
    Matching Buyers (10)
  </Button>

  <Button
    variant="contained"
    sx={{
      backgroundColor: '#E74C3C',
      color: 'white',
      fontSize: '0.60rem',
      textTransform: 'none',
      flex: 1,
      minWidth: '100px',
      '&:hover': { backgroundColor: '#c0392b' },
    }}
  >
    Delete
  </Button>
</Box>

{/* Extension Button + Days Left */}
<Box
  sx={{
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#eee',
    borderRadius: 1,
    p: 1,
    flexWrap: 'wrap',
  }}
>
  <Button
    variant="contained"
    fullWidth={false}
    sx={{
      backgroundColor: '#d3d3d3',
      color: '#000',
      fontWeight: 600,
      textTransform: 'none',
      fontSize: '0.9rem',
      px: 3,
      py: 1,
      borderRadius: 1,
      '&:hover': { backgroundColor: '#c0c0c0' },
    }}
  >
    Extension Your Post
  </Button>

  <Typography
    variant="body2"
    sx={{
      fontWeight: 'bold',
      color: 'red',
      fontSize: '0.85rem',
      ml: 'auto',
      mt: { xs: 1, sm: 0 },
    }}
  >
    Days left: <span style={{ color: '#E74C3C' }}>120 Days</span>
  </Typography>
</Box>

      </CardContent>
    </Card>
  );
};

export default Three;
